module.exports = __webpack_public_path__ + "static/media/modeldemo.a4cafffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeldemo.png
// module id = 380
// module chunks = 0